import explore_image from '@/public/features/explore.webp';
import schedule_2 from '@/public/features/invoicing/Communication-Tools-_2_.webp';
import bg from '@/public/features/invoicing/invoice-661177e254df6.webp';
import schedule_1 from '@/public/features/invoicing/mobile-invoicing-capability-1-66117851cb1e7.webp';
import schedule_3 from '@/public/features/invoicing/mobile-invoicing-capability-66117852ca6b3.webp';
import app_2 from '@/public/features/invoicing/What-is-invoicing-software (1).webp';
import app_1 from '@/public/features/scheduling/App_1.webp';
import { CalendarIcon, CardIcon, ToolsIcon, WalletIcon } from '@/public/icons';
import { ArticleType } from '@/types/articles';
import { IRoutePath } from '@/types/router';

const intro = {
  tag: 'Field Service Invoicing Software',
  description: `Experience hassle-free invoicing with our field service invoicing software. Tailored for on-the-go billing, it offers real-time tracking, customizable invoices, and instant updates, ensuring efficiency and accuracy. Simplify your invoicing process, enhance cash flow, and reduce paperwork.`,
  imageSrc: bg.src,
  image: bg,
  first_title: 'Streamline Invoicing with',
  second_title: 'Our Software',
};

const faq = {
  title: 'FAQ',
  items: [
    {
      title: 'What are the benefits of invoicing software for my business?',
      text: `Invoicing software automates the billing process, ensuring accuracy and saving time. By using service invoicing software, you'll enjoy faster payment processing, streamlined workflow, professional-looking invoices, and an overall increase in efficiency, allowing you to focus on growing your business rather than on paperwork.`,
    },
    {
      title: `Is it easy to switch from paper invoices to electronic invoices?`,
      text: `Transitioning is user-friendly and efficient. Modern service invoicing software typically comes with intuitive setup wizards, import tools, and customer support to help transfer your existing data into the new system, making the changeover from paper to electronic both smooth and quick.`,
    },
    {
      title: `What is the best invoicing software for small businesses?`,
      text: `The ideal invoicing software for small businesses combines user-friendliness, cost-effectiveness, and comprehensive features. Many providers offer free field services invoicing software as a starting point, with the option to scale up as your business grows, giving you value without compromising on functionality.`,
    },
  ],
};

const testimonals = {
  title: 'Our Testimonials',
  description: '',
  items: [
    {
      text: `Orcatec's free invoicing tier has been a cool step. We can now enjoy professional billing without the cost, and it's incredibly user-friendly. The ability to scale with their paid packages means they'll grow with us!`,
      name: 'Elena Rodriguez,',
      position: 'Innovate Startups',
    },
    {
      text: `Never thought invoicing could be this easy. Orcatec's software has saved us countless hours. The flexibility in their service packages allowed us to choose exactly what we need. Plus, their support team is always there when you need them.`,
      name: 'Chris Thompson,',
      position: 'Thompson Tech Solutions',
    },
    {
      text: `We particularly love how the system adapts to our complex billing requirements with such ease. The customers appreciate the clarity of invoices, and we appreciate the efficiency. Thx to Orcatec. `,
      name: 'Rachel Kim,',
      position: 'Elite Marketing Solutions',
    },
  ],
};

const blog = {
  title: 'Our Blog',
  description: `It is your hub for insights, tips, and updates on mastering the art of invoicing and business management. Dive into expert articles that help you leverage Orcatec’s features for maximum efficiency. `,
};

const bookDemo = {
  title: `Book A Demo Of Our Invoice Feature!`,
  description: `Schedule a live demo today and witness firsthand the power and simplicity of our service invoicing software. Our team will guide you through the key features and answer any questions you may have.`,
};

const articles = {
  title: `Software Features Made for Invoicing Businesses`,
  items: [
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_1,
        alt: 'Manual Invoice Customization',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Manual Invoice Customization',
      text: `Orcatec's field service invoicing system also supports manual invoice customization for those unique jobs that require a personal touch. Adjust rates, add special discounts, or tailor descriptions to match the service provided. This feature gives you the flexibility to address the specific needs of each job while maintaining the professional appearance of your invoices.`,
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_2,
        alt: 'Real-Time Tracking and Updating',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Real-Time Tracking and Updating',
      text: `Stay on top of your billing with our free field services invoice software. Real-time updates provide a clear view of invoicing statuses, from sent to settled accounts, enhancing your ability to manage cash flow and customer follow-up. Instant notifications keep you informed every step of the way.`,
    },
    {
      type: ArticleType.HORIZONTAL,
      image: {
        path: schedule_3,
        alt: 'Mobile Invoicing Capability',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Mobile Invoicing Capability',
      text: `Orcatec's field service invoicing app allows you to issue invoices directly from your phone or tablet. This empowers your team to complete billing on-site immediately after service completion, offering convenience and speeding up the payment process for both you and your customers.`,
    },
  ],
};

const fullArticle1 = {
  image: {
    path: app_1,
    alt: `Why Orcatec 
    is Right For You?`,
  },
  title: `Why Orcatec 
  is Right For You?`,
  description: `Orcatec's field service invoice software offers a significant advantage over traditional invoicing methods for businesses that rely on field technicians. Find out the main reasons for choosing us:`,
  item: [
    {
      title: 'Cost Efficiency',
      description:
        'Orcatec offers a free field service billing software tier designed for the financial needs of small businesses and startups. Gain access to professional invoicing tools without the investment, allowing you to allocate resources to other areas of your business while maintaining billing excellence.',
    },
    {
      title: 'Flexible Function Choice',
      description: `With Orcatec, you can customize your experience to match your specific operational requirements. Our software is adaptable, so you can start with what you need and add more functions as your business grows, ensuring that our solution evolves alongside your company.`,
    },
    {
      title: 'Advanced Support ',
      description: `Support is always within reach with Orcatec. Our responsive online support team ensures you have the help you need whenever you encounter an obstacle, promoting continuous operation without disruption.`,
    },
  ],
};

const fullArticle2 = {
  image: {
    path: app_2,
    alt: `What Is Invoicing Software?`,
  },
  title: `What Is Invoicing Software?`,
  description: `Invoicing software is a digital tool that allows businesses to generate bills for products or services rendered. This software automates the traditional invoicing process, providing a more efficient, accurate, and streamlined billing and account management method. So, how can field service invoice software be useful?`,
  item: [
    {
      title: 'Automated data capture',
      description:
        'Integration with other field service software, like job scheduling or time tracking, helps create detailed invoices based on services provided.',
    },
    {
      title: 'Offline functionality',
      description:
        'Invoice schedules help send automated reminders to clients for upcoming or overdue payments without your actions.',
    },

    {
      title: 'Multiple payment options',
      description: `Invoicing software offers various payment options like credit card processing or ACH payments through the invoice itself, improving convenience for customers.`,
    },
  ],
};

const explore = {
  title: 'Explore More ',
  subtitle: 'Tools For Job Success',
  description: `Dive into a wealth of insights tailored to your industry with Orcatec's blog, your go-to resource 
  for the latest trends and tips in service scheduling software free`,
  image: explore_image,
  items: [
    {
      title: 'Complete Job & Invoice',
      path: IRoutePath.FEATURES_INVOICING,
      icon: WalletIcon,
      items: [
        {
          title: 'Sales Proposal Tool',
          path: '',
        },

        {
          title: 'Invoicing',
          path: '',
        },
        {
          title: 'Estimates',
          path: '',
        },
        {
          title: 'Quoting',
          path: '',
        },
      ],
    },
    {
      title: 'Scheduling & Dispatching',
      path: IRoutePath.FEATURES_SCHEDULIG,
      icon: CalendarIcon,
      items: [
        {
          title: 'Employee GPS Tracking',
          path: '',
        },
        {
          title: 'Scheduling Software',
          path: '',
        },
        {
          title: 'Route Optimization',
          path: '',
        },
        {
          title: 'Field Service App',
          path: '',
        },
        {
          title: 'Voice Solutions',
          path: '',
        },
        {
          title: 'Dispatching',
          path: '',
        },
      ],
    },
    {
      title: 'Get Paid & Expenses',
      path: IRoutePath.FEATURES,
      icon: CardIcon,
      items: [
        {
          title: 'Commissions Management',
          path: '',
        },
        {
          title: 'Home Services Marketing',
          path: '',
        },
        {
          title: 'Automated Direct Mail',
          path: '',
        },
        {
          title: 'Consumer Financing',
          path: '',
        },
        {
          title: 'Advanced Reporting',
          path: '',
        },
        {
          title: 'Expenses Tracking',
          path: '',
        },

        {
          title: 'Contractor Payroll',
          path: '',
        },
        {
          title: 'Card Reader',
          path: '',
        },
      ],
    },
    {
      title: 'Job Management',
      icon: ToolsIcon,
      path: IRoutePath.FEATURES,
      items: [
        {
          title: 'Work Order Management',
          path: '',
        },
        {
          title: 'Field Service CRM',
          path: '',
        },
        {
          title: 'Job Management',
          path: '',
        },
        {
          title: 'Job Tracking',
          path: '',
        },
        {
          title: 'Job Costing',
          path: '',
        },
      ],
    },
  ],
};

export {
  articles,
  blog,
  bookDemo,
  faq,
  fullArticle1,
  fullArticle2,
  intro,
  testimonals,
  explore,
};
